import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import axios from "axios";
import classNames from "classnames";

import {selectCategory, toggleBoxLoading, resetVehicle} from "../actions";
import BoxTitle from "../components/BoxTitle";
import BoxInput from "../components/BoxInput";
import PartNameResults from "../components/PartNameResults";
import {onElementAppear, onElementExit} from '../utils'
import {Flipped} from "react-flip-toolkit";

class PartNameBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchValue: "",
            categoriesResults: null,
            displayResults: false
        }

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this.timer = null;
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({displayResults: false})
        }
    }

    handleInputChange(event) {
        this.setState({searchValue: event.target.value});
        this.setState({displayResults: true})
        clearTimeout(this.timer);
        this.timer = setTimeout(
            () => {
                this.state.searchValue.length > 2 ? this.searchCategories() : this.setState({categoriesResults: null})
            },
            300
        );
    }

    searchCategories() {
        if (!this.state.searchValue) {
            return;
        }
        let requestUrl = '/partauto/api/categories';
        requestUrl += '?search=' + this.state.searchValue;

        if (this.props.vehicle.type.id) {
            requestUrl += '&type_id=' + this.props.vehicle.type.id;
        }

        this.props.toggleBoxLoading('partName');


        axios(requestUrl)
            .then(function (response) {
                this.setState({displayResults: true});
                this.setState({categoriesResults: response.data});
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            }).finally(() => this.props.toggleBoxLoading('partName'))
    }

    handleSelectCategory(category) {
        this.props.selectCategory(category);
    }

    render() {
        let bActive=this.props.activeTab === 'part_name';
        const containerClasses = classNames(
            'part_name_box',
            {
                'loading': this.props.statuses.partName.loading,
                'completed': this.props.completed,
                'active': this.props.activeTab === 'part_name'
            }
        );

        return (
            <Flipped
                flipId={`part_name_box`}
                onDelayedAppear={onElementAppear}
                onExit={onElementExit}
                key={`part_name_box`}
                delay={2}
                translate
                opacity
            >
                <div className={containerClasses}>
                    <BoxTitle title="Rechercher une pièce par son nom"/>
                    <div className="form_input_group">
                        <BoxInput focusAction={() => this.setState({displayResults: true})}
                                  clickAction={() => this.setState({displayResults: true})}
                                  changeAction={(e) => this.handleInputChange(e)} value={this.state.searchValue}
                                  placeholder={"Filtre à air, disques de frein, ..."}
                                  classNames={SELECTED_VEHICLE!=null?' blink':""}
                                  autoFocus={bActive}
                                  focus={bActive}
                                  />
                        <span>
                            <i className="material-icons">
                                search
                            </i>
                            <p className="small">
                                ABC
                            </p>
                        </span>
                    </div>
                    {this.state.categoriesResults && this.state.displayResults ?
                        (
                            <div ref={this.setWrapperRef} className="part_name_results">
                                <PartNameResults search={this.state.searchValue} results={this.state.categoriesResults}
                                                 categorySelectAction={this.handleSelectCategory.bind(this)}/>
                            </div>
                        )
                        : null
                    }
                    {this.props.vehicle.type.id ?
                        <div className="catalog_link hide-on-mobile">
                            <a href="/#catalog">Ou rechercher dans la liste des catégories ci-dessous</a>
                        </div>
                        : null}
                    {this.props.statuses.partName.loading ? <div className="loading"></div> : null}
                </div>
            </Flipped>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        vehicle: state.vehicle,
        category: state.category,
        statuses: state.boxStatuses
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectCategory,
        toggleBoxLoading,
        resetVehicle
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PartNameBox)